const NON_VISUAL_TAGS = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'META', 'LINK']);

function hasRenderableMeaning(element) {
  if (NON_VISUAL_TAGS.has(element.tagName)) return false;
  if (element.textContent?.trim()) return true;
  if (element.getAttribute('aria-label')?.trim()) return true;
  return ['CANVAS', 'IMG', 'INPUT', 'SVG', 'VIDEO'].includes(element.tagName);
}

function isActuallyVisible(element, boundary) {
  const rect = element.getBoundingClientRect();
  if (!(rect.width > 0 && rect.height > 0)) return false;

  let current = element;
  while (current) {
    const style = window.getComputedStyle(current);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.visibility === 'collapse' ||
      Number.parseFloat(style.opacity || '1') <= 0
    ) {
      return false;
    }
    if (current === boundary) break;
    current = current.parentElement;
  }

  return current === boundary;
}

export function hasVisibleBrandedSurface(shell) {
  if (!shell || shell.getAttribute('data-emberpos-brand') !== 'EmberPOS') return false;

  return Array.from(shell.querySelectorAll('*')).some(
    (element) => hasRenderableMeaning(element) && isActuallyVisible(element, shell),
  );
}
